import React from 'react';
import theme from './Cards.module.scss';
import { NoResultsCardProps } from '.';
import SimpleCard from './SimpleCard';
import { classnames } from '@/utils/html';
import { Trans } from '@lingui/react/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const NoResultsCard: React.FC<NoResultsCardProps> = ({
    children = <Trans>No results</Trans>,
    className,
    icon,
    title,
    ...rest
}) => {
    return (
        <SimpleCard {...rest} className={classnames(className, [theme.noResultsCard])}>
            {icon && (
                <div className={theme.iconRow}>
                    <FontAwesomeIcon icon={icon} />
                </div>
            )}
            {title && <h3>{title}</h3>}
            <div className={theme.content}>{children}</div>
        </SimpleCard>
    );
};

export default NoResultsCard;